<template>
    <section class="header__bottom d-flex align-items-center row">
        <div class="col-xl-3 box__first">
            <button>
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M20.5768 12.8078H2.80769C2.36184 12.8078 2 12.4459 2 12.0001C2 11.5542 2.36184 11.1924 2.80769 11.1924H20.5768C21.0227 11.1924 21.3845 11.5542 21.3845 12.0001C21.3845 12.4459 21.0227 12.8078 20.5768 12.8078Z"
                        fill="#313D65"
                    />
                    <path
                        d="M20.5768 6.61538H2.80769C2.36184 6.61538 2 6.25353 2 5.80769C2 5.36184 2.36184 5 2.80769 5H20.5768C21.0227 5 21.3845 5.36184 21.3845 5.80769C21.3845 6.25353 21.0227 6.61538 20.5768 6.61538Z"
                        fill="#313D65"
                    />
                    <path
                        d="M20.5768 19.0001H2.80769C2.36184 19.0001 2 18.6383 2 18.1925C2 17.7466 2.36184 17.3848 2.80769 17.3848H20.5768C21.0227 17.3848 21.3845 17.7466 21.3845 18.1925C21.3845 18.6383 21.0227 19.0001 20.5768 19.0001Z"
                        fill="#313D65"
                    />
                </svg>

                <span>
                    Каталог товаров
                </span>
            </button>
        </div>

        <div class="col-xl-9 col-l-12 box__second addition">
            <router-link :to="{ name: 'help' }" class="main_link">
                Как купить?
            </router-link>

            <router-link
                :to="{ name: 'allbrands' }"
                class="main_link moreLess"
            >
                Бренды
            </router-link>

            <router-link :to="{ name: 'aboutus' }" class="main_link moreLess">
                О нас
            </router-link>

            <a
                href="https://forms.gle/6GRdsBnz85JPciSP9"
                target="_blank"
                rel="noopener noreferrer"
                class="red_link"
            >
                Партнерам
            </a>

            <router-link :to="{ name: 'contacts' }" class="main_link">
                Контактыr
            </router-link>

            <a href="tel:+998773335000" class="main_link">
                +998 77 333 50 00
            </a>
        </div>

        <div class="flicking box__second">
            <Flicking
                class="carousel"
                :options="{
                    align: 'prev',
                    circular: true,
                    duration: 1000
                }"
                ref="flicking"
            >
                <div class="panel">
                    <router-link :to="{ name: 'help' }" class="main_link">
                        Как купить?
                    </router-link>
                </div>

                <div class="panel">
                    <router-link :to="{ name: 'aboutus' }" class="main_link">
                        О нас
                    </router-link>
                </div>

                <div class="panel">
                    <a
                        href="https://forms.gle/6GRdsBnz85JPciSP9"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="red_link"
                    >
                        Партнерам
                    </a>
                </div>

                <div class="panel">
                    <router-link :to="{ name: 'contacts' }" class="main_link">
                        Контакты
                    </router-link>
                </div>

                <div class="panel">
                    <a href="tel:+998773335000" class="main_link">
                        +998 77 333 50 00
                    </a>
                </div>
            </Flicking>
        </div>
    </section>
</template>

<script>
import { Flicking } from "@egjs/vue-flicking";
export default {
    components: {
        Flicking
    },

    data() {
        return {
            interval: 0
        };
    },

    methods: {
        intervalStart() {
            this.interval = setInterval(() => {
                this.$refs.flicking.next().catch(() => void 0);
            }, 0);
        },

        intervalStop() {
            clearInterval(this.interval);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../../sass/_mixins.scss";
@import url("../../../../node_modules/@egjs/vue-flicking/dist/flicking.css");
// Or, if you have to support IE9
@import url("../../../../node_modules/@egjs/vue-flicking/dist/flicking-inline.css");

.header__bottom {
    margin-top: -30px;
    height: 50px;

    .box__first {
        height: 100%;
        padding: 0;

        button {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            width: 100%;
            height: 100%;
            padding-top: 4px;
            background-color: #f2f2f3;
            outline: none;
            border: none;

            svg {
                position: absolute;
                top: 50%;
                left: 35px;
                transform: translateY(-50%);
            }

            span {
                font-family: Acrom-Medium, sans-serif;
                font-size: 18px;
                /* MAIN2 */
                color: #3E5C45;
            }
        }
    }

    .box__second {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        height: 100%;

        .main_link {
            @include simpleBtn;
            font-size: 15px;
            font-family: Acrom-Medium, sans-serif;
        }

        .red_link {
            color: #fff;
            padding: 4px 9px;
            background-color: #cc3a3a;
            border-radius: 4px;

            font-size: 15px;
            line-height: 1;
            font-family: Acrom-Medium, sans-serif;
        }

        .language_switcher {
            margin-left: 17.5px;
            padding: 5px 7px;
            background-color: #f2f2f3;
            border-radius: 3px;
            border: 1px solid #e1e1e1;
            font-family: Acrom-Medium, sans-serif;
            font-style: normal;
            font-size: 12px;
            /* black_main */
            color: #363f4d;
        }
    }

    .flicking {
        display: none;
        border-bottom: 1px solid #f2f2f3;
    }
}

@media only screen and (min-width: 1440px) {
    .header__bottom {
        max-width: 1440px;
        margin-right: auto !important;
        margin-left: auto !important;
    }
}

@media only screen and (max-width: 1200px) {
    .header__bottom {
        .box__first {
            display: none;
        }

        .box__second {
            justify-content: space-between;
        }
    }
}

@media only screen and (min-width: 1200px) {
    .header__bottom {
        .box__second {
            border: 1px solid #f2f2f3;
        }
    }
}

@media only screen and (max-width: 784px) {
    .header__bottom {
        .box__second {
            .moreLess {
                display: none;
            }
        }
    }
}

@media only screen and (max-width: 560px) {
    .header__bottom {
        height: 30px;
        margin-top: -20px;
        box-shadow: 0 2px 1px -0.5px rgb(0 0 0 / 15%);

        .addition {
            display: none;
        }

        .flicking {
            display: flex;
            height: 30px;
            width: 100%;

            .panel {
                height: 30px;
                display: flex;
                align-items: center;

                .main_link {
                    margin-right: 15px;
                    margin-left: 15px;
                    font-size: 13px;
                }
            }
        }
    }
}
</style>
